import { render, staticRenderFns } from "./DataAnalysisModalJoinComponent.vue?vue&type=template&id=412484a5"
import script from "./DataAnalysisModalJoinComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisModalJoinComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports